import { PhoneNumber } from 'utils';
import * as Yup from 'yup';

export default () =>
  Yup.object().shape({
    givenName: Yup.string().required('Prénom requis !'),
    familyName: Yup.string().required('Nom requis !'),
    phoneNumber: Yup.string().test(
      'is-valid',
      'Numéro de téléphone invalide !',
      (value) => !value || PhoneNumber.isValid(value),
    ),
    email: Yup.string().email('Adresse email non valide !'),
  });
